/* eslint-disable react/prop-types */
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { observer } from "mobx-react";
import Price from "./Price";
import QuantityIndicator from "./QuantityIndicator";
import Tags from "./Tags";
import AddToCart from './AddToCart';
import ProductImage from './ProductImage';

const CrossSellView = observer(({
  product,
  inCart,
  img,
  handleClick,
  selectedVariation,
  setSelectedVariation,
  productType,
  productDisplayType,
  setProductDisplayType,
  handleRemoveFromCart,
  handleAddToCart,
  handleClearFromCart,
  handleUpdateQuantity,
  productWeightQuantity,
  quantity,
  handleVariationChange,
  studioStore,
}) => {
  const [isImageHovered, setIsImageHovered] = useState(false);
  const t = useTranslations('Product');
  const primaryColor = studioStore?.settings?.colors?.primary_color;

  return (
    <>
      <header className="relative text-center">
        <div className="bg-yellow-400 text-xs p-1 pe-8">
          {t('crosssell_title')}
        </div>
        <div
          className="relative w-auto pt-2 px-2 pe-8"
          onMouseEnter={() => setIsImageHovered(true)}
          onMouseLeave={() => setIsImageHovered(false)}
        >
          <div className="w-full p-2">
            <Tags product={product} />
          </div>
          <div className="relative w-full">
            <ProductImage img={img} productName={product?.name} />
            <AnimatePresence>
              {isImageHovered && (
                <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="absolute inset-0 flex flex-col items-center justify-center z-30"
              >
                {/* Background with opacity */}
                <div
                  className={`absolute stamp-border stamp-border-md inset-0 z-[-1] ${!primaryColor && 'bg-gray-500'}`}
                  style={{
                    backgroundImage: `radial-gradient(7px, rgba(255, 255, 255, 0) 98%, ${primaryColor}), linear-gradient(${primaryColor} 0 0)`,
                    opacity: 0.50,
                  }}
                  />
                  {/* Content without opacity */}
                  <div className="relative z-10">
                    <AddToCart
                      product={product}
                      handleRemoveFromCart={handleRemoveFromCart}
                      handleAddToCart={handleAddToCart}
                      handleUpdateQuantity={handleUpdateQuantity}
                      productWeightQuantity={productWeightQuantity}
                      quantity={quantity}
                      handleVariationChange={handleVariationChange}
                      productType={productType}
                      selectedVariation={selectedVariation}
                      setSelectedVariation={setSelectedVariation}
                      productDisplayType={productDisplayType}
                    />
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
        <div className="product-info p-3 md:p-5 md:py-6 pe-8 md:pe-8">
          <h3
            className="mb-2 text-lg font-bold truncate text-heading"
            onClick={handleClick}
            style={{color: primaryColor}}
          >
            {product.name}
          </h3>
          <Price
            product={selectedVariation || product}
            productType={productType}
            productDisplayType={productDisplayType}
            setProductDisplayType={setProductDisplayType}
          />
        </div>
      </header>
      <div className="absolute bottom-0 left-0 p-4 pe-8">
        <QuantityIndicator inCart={inCart} handleClearFromCart={handleClearFromCart} />
      </div>
    </>
  );
});

export default CrossSellView;
